import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import BugReportIcon from '@material-ui/icons/BugReport';
import GitHubIcon from '@material-ui/icons/GitHub';
import ThemeChangerSlide from './ThemeChangerSlide';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    rightButtons: {
        margin: theme.spacing(1),
    },
    title: {
        flexGrow: 1,
    },
}));

export default function TopAppBar() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar>
                    <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>Surveyz.xyz</Typography>
                    <ThemeChangerSlide />
                    <Button variant="contained" target="_blank" rel="noopener" href="https://github.com/jpiechowka/surveyz.xyz-frontend/issues" className={classes.rightButtons} startIcon={<BugReportIcon />}>Report Bugs</Button>
                    <Button variant="contained" target="_blank" rel="noopener" href="https://github.com/jpiechowka/surveyz.xyz-frontend" className={classes.rightButtons} startIcon={<GitHubIcon />}>Source Code</Button>
                </Toolbar>
            </AppBar>
        </div>
    );
}
